<p class="title">
  {{ 'MANAGE_VACATIONS.SELECT_' + (isMomoUser ? 'VACATIONS' : 'PROPOSAL') + '_TO_REQUEST_1' | translate }}
  <b> {{ 'MANAGE_VACATIONS.' + selectedSeason.id | uppercase | translate | lowercase }}</b>
  {{ 'MANAGE_VACATIONS.SELECT_' + (isMomoUser ? 'VACATIONS' : 'PROPOSAL') + '_TO_REQUEST_2' | translate }}
</p>
<div class="grid">
  <div *ngIf="!emptySlots; else empty">
    <div class="row">
      <div class="col" *ngFor="let month of calendar?.months; trackBy: trackByItems" size="4">
        <div class="month padding">
          <p class="month__title black-text">{{ month.monthLabel }} {{ month.yearLabel }}</p>
          <div *ngIf="month.weeks.length; else emptyWeeks">
            <app-header-label-days [shortDays]="true"></app-header-label-days>
            <app-season-calendar-month
              [month]="month"
              [selectedSlots]="selectedSlots$"
              [defaultColours]="calendar.colours"></app-season-calendar-month>
            <div class="slots">
              <p
                class="black-text"
                *ngFor="let slot of month.slots; trackBy: trackByItems"
                [class.selected]="isSelectedSlot(slot) !== -1"
                (click)="selectSlot(slot)">
                {{ slot.description }}
                <img
                  slot="end"
                  *ngIf="isSelectedSlot(slot) !== -1"
                  src="assets/imgs/profile/language/check-green.svg"
                  alt="Check" />
              </p>
            </div>
          </div>
          <ng-template #emptyWeeks>
            <div class="empty-weeks-container">
              <img [src]="notSelectedSeason.img" />
              <p class="black-text">{{ 'MANAGE_VACATIONS.EMPTY_MONTH_MSG_1' | translate }}</p>
              <p class="black-text">
                {{ 'MANAGE_VACATIONS.EMPTY_MONTH_MSG_2' | translate : { season: notSelectedSeason.title | lowercase } }}
              </p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <app-caption-leyend [caption]="calendar?.captions" [popover]="false"> </app-caption-leyend>
  </div>
  <ng-template #empty>
    <div class="empty-slots-container">
      <img src="assets/imgs/no-results/empty.svg" alt="Error Info Image" />
      <h5>{{ emptySlots.message }}</h5>
    </div>
  </ng-template>
</div>
